export default __webpack_public_path__ + "static/media/car_keys.25191485.png";